import ChapterLeaderboard from 'routes/ChapterAnalytics/ChapterLeaderboard/ChapterLeaderboard';

export default ChapterLeaderboard;
